import React, { createContext, useState } from "react";
import broadcastService from "../components/services/broadcastService";

const BroadcastContext = createContext();

export const BroadcastProvider = ({ children }) => {
  const [broadcasts, setBroadcasts] = useState([]);

  const loadBroadcasts = async () => {
    const data = await broadcastService.getBroadcasts();
    setBroadcasts(data);
  };

  return (
    <BroadcastContext.Provider value={{ broadcasts, loadBroadcasts }}>
      {children}
    </BroadcastContext.Provider>
  );
};

export default BroadcastContext;
